/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Visceral_FatInputs */

const en_us2_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is an estimate from your outer outline: it cannot see visceral fat.`)
};

const pt_br2_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é uma estimativa do contorno externo: ela não enxerga gordura visceral.`)
};

const es_419_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es una estimación a partir de tu contorno exterior: no puede ver la grasa visceral.`)
};

const pt_pt2_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é uma estimativa a partir do contorno exterior: não consegue ver a gordura visceral.`)
};

const fr_fr2_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est une estimation à partir de ta silhouette extérieure : elle ne voit pas la graisse viscérale.`)
};

const de_de2_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist eine Schätzung aus deinem äußeren Umriss: Viszeralfett sieht sie nicht.`)
};

const it_it2_body_assessment_warning_visceral_fat = /** @type {(inputs: Body_Assessment_Warning_Visceral_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È una stima dalla sagoma esterna: non può vedere il grasso viscerale.`)
};

/**
* | output |
* | --- |
* | "This is an estimate from your outer outline: it cannot see visceral fat." |
*
* @param {Body_Assessment_Warning_Visceral_FatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_visceral_fat = /** @type {((inputs?: Body_Assessment_Warning_Visceral_FatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Visceral_FatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_visceral_fat(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_visceral_fat(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_visceral_fat(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_visceral_fat(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_visceral_fat(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_visceral_fat(inputs)
	return en_us2_body_assessment_warning_visceral_fat(inputs)
});
export { body_assessment_warning_visceral_fat as "body-assessment.warning.visceral_fat" }